// extracted by mini-css-extract-plugin
export default {"commentsContainer":"Comments_commentsContainer__0iVjn","textField":"Comments_textField__Nk82i","submitButton":"Comments_submitButton__k-Tl2"};